<template>
  <div>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />

    <section class="person-section" v-if="appointment && appointment.person">
      <h6 class="is-bold">
        {{$t('clinical.people.details')}}
      </h6>

      <PersonInfo :person="appointment.person" />
    </section>

    <section class="questionnaire-section" v-if="appointment">
      <h6 class="is-bold">
        {{$t('clinical.people.anamnesis.clinical_questionnaire')}}
      </h6>

      <OtoscopyForm
        class="ml-3"
        :value="Array.isArray(appointment.otoscopies) && appointment.otoscopies.length > 0 ? appointment.otoscopies[0] : null"
        :collapsable="true"
        :editing="false"
      />

      <ImpedanceForm
        class="ml-3"
        :value="Array.isArray(appointment.impedances) && appointment.impedances.length > 0 ? appointment.impedances[0] : null"
        :collapsable="true"
        :editing="false"
      />

      <TonalAudiometryForm
        class="ml-3"
        :value="Array.isArray(appointment.tonal_audiometries) && appointment.tonal_audiometries.length > 0 ? appointment.tonal_audiometries[0] : null"
        :collapsable="true"
        :editing="false"
      />

      <VocalAudiometryForm
        class="ml-3"
        :value="Array.isArray(appointment.vocal_audiometries) && appointment.vocal_audiometries.length > 0 ? appointment.vocal_audiometries[0] : null"
        :collapsable="true"
        :editing="false"
      />

      <ObservationsForm
        class="ml-3"
        :value="appointment.anamnesis_obs"
        :collapsable="false"
        :editing="false"
      />

    </section>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/common/Breadcrumbs'
import PersonInfo from '@/components/clinical/people/PersonDetails/PersonInfo'
import { RequestService } from '@/api/EvocallService'
import { AppointmentService } from '@/api/AuthClinicalService'
import OtoscopyForm from '@/components/clinical/people/Anamnesis/OtoscopyForm'
import TonalAudiometryForm from '@/components/clinical/people/Anamnesis/TonalAudiometryForm'
import VocalAudiometryForm from '@/components/clinical/people/Anamnesis/VocalAudiometryForm'
import ObservationsForm from '@/components/clinical/people/Anamnesis/ObservationsForm'
import ImpedanceForm from "@/components/clinical/people/Anamnesis/ImpedanceForm";

export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  components: {
    ImpedanceForm,
    Breadcrumbs,
    PersonInfo,
    OtoscopyForm,
    ObservationsForm,
    TonalAudiometryForm,
    VocalAudiometryForm
  },
  data () {
    return {
      request: null,
      appointment: null
    }
  },
  computed: {
    authClinicalService: function () {
      return this.request ? this.$store.state.services.find(s => s.id === this.request.service_id) : null
    },
    breadcrumbs: function () {
      let breadcrumbs = [
        { title: this.$t(`menu.${this.serviceSlug}`), disabled: true },
        { title: this.$t('menu.evocall/history'), meta: { type: 'function', value: () => { this.$router.push({ name: `${this.serviceSlug}evocall/history` }) } } }
      ]

      if (this.appointment) {
        breadcrumbs.push({ title: `${this.appointment.person.name}`, active: true })
      }

      return breadcrumbs
    }
  },
  methods: {
    selectRequest: function (requestId) {
      RequestService.get(requestId)
        .then(request => {
          this.request = request
          AppointmentService.get(this.authClinicalService.url, this.request.appointment_id)
            .then(appointment => {
              this.appointment = appointment
              this.isLoading = false
            })
            .catch(errors => {
              this.isLoading = false
            })
        }).catch(errors => {
          console.log(errors)
          this.isLoading = false
          this.redirectBack()
        })
    },
    redirectBack: function () {
      this.$router.push({ name: 'evocallevocall/history' })
    }
  },
  beforeRouteEnter (to, from, next) {
    if (to.params.id !== undefined) {
      next(vm => {
        vm.selectRequest(parseInt(to.params.id))
        vm.from = from
      })
    } else {
      next(from)
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.id !== undefined) {
      this.selectRequest(parseInt(to.params.id))
    } else {
      next(from)
    }
  }
}
</script>
